import styled from '@emotion/styled';
import { type TFunction, useTranslation } from 'react-i18next';
import { TabsButton } from '__components/Inputs/Select/TabsButton';
import { TABS } from './constants';

type Tab = 'scheduled' | 'logged';

type ScheduledLoggedNavigationProps = {
  tab: Tab;
  onSelectTab(value: Tab): void;
};

const subRoutes = (t: TFunction) => [
  {
    tabKey: TABS.scheduled,
    label: t('Scheduled'),
  },
  {
    tabKey: TABS.logged,
    label: t('Logged'),
  },
];

const StyledTabsWrapper = styled.div`
  background-color: var(--color-background-white);
  max-width: 450px;
  width: 100%;

  button:not(:last-of-type) {
    border-right: 1px solid var(--color-border-medium-light);
  }

  button:focus {
    outline: 0;
  }

  button:after {
    height: 0px;
  }
`;

export const ScheduledLoggedNavigation = (
  props: ScheduledLoggedNavigationProps
) => {
  const { tab, onSelectTab } = props;
  const { t } = useTranslation();

  return (
    <StyledTabsWrapper>
      <TabsButton
        onSelectTab={(value: any) => {
          onSelectTab(value.tabKey);
        }}
        options={subRoutes(t)}
        selectedTab={tab}
      />
    </StyledTabsWrapper>
  );
};
